<div>
    <app-tool-bar [title]="'Fee Breakdown'" [iconName]="'pi-money-bill'" [isAdd]="true"
        (handleAdd)="handleFeeBreakdown()"></app-tool-bar>
</div>


<div class="p-4 overflow-auto h-[85vh]">

    <!-- Total Fee Card -->
    <div class="mb-6 p-5 rounded-2xl shadow-lg 
            flex justify-between items-center border border-blue-200">

        <!-- Left Content -->
        <div class="flex items-center gap-4">
            <!-- Icon Circle -->
            <div class="p-3 rounded-full bg-blue-100 shadow-md">
                <i class="pi pi-wallet text-blue-600 text-2xl"></i>
            </div>

            <!-- Text -->
            <div>
                <div class="text-lg font-semibold text-gray-700">
                    Total Fee Amount
                </div>
                <p class="text-sm text-gray-500">
                    {{ responseData?.group_name }}
                </p>
            </div>
        </div>

        <!-- Right Content -->
        <div class="text-right">
            <span class="text-2xl font-bold text-blue-700">
                {{ responseData?.total_fees | currency: responseData?.currency:'symbol' }}
            </span>
            <p class="text-sm text-gray-500">Including all charges</p>
        </div>
    </div>


    <!-- Fee Breakdown Table -->
    <p-table [value]="feeList" [loading]="loading" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20,50]"
        [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">

        <!-- Table Header -->
        <ng-template pTemplate="header">
            <tr>
                <th>S.No</th>
                <th>Fee Name</th>
                <th>Amount</th>
                <th>Created Date</th>
                <th>Actions</th>
            </tr>
        </ng-template>

        <!-- Table Body -->
        <ng-template pTemplate="body" let-row let-i="rowIndex">
            <tr>
                <td>{{ i + 1 }}</td>
                <td>{{ row.fee_name }}</td>
                <td>{{ row.amount | number:'1.0-2' }}</td>
                <td>{{ row.createdAt | date:'medium' }}</td>
                <td>
                    <div *ngIf="!loading" (click)="setRowData(row)">
                        <p-menu [tabindex]="undefined" #menu [model]="feeActionItem" [popup]="true"
                            appendTo="body"></p-menu>
                        <i (click)="menu.toggle($event)" class="pi pi-ellipsis-h action-button"></i>
                    </div>
                </td>
            </tr>
        </ng-template>

        <!-- Table Footer (Total Calculation) -->
        <ng-template pTemplate="footer">
            <tr class="font-bold">
                <td></td>
                <td class="text-right">Total</td>
                <td>{{ getTotalAmount() | currency: responseData?.currency:'symbol' }}</td>
                <td></td>
                <td></td>
            </tr>
        </ng-template>



        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="5" class="no-data">
                    <p>No Breakdown found</p>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>



<p-dialog [modal]="true" *ngIf="isAddFeeStructure" [(visible)]="isAddFeeStructure"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-fee-structure [group_id]="feeGroupId" (closeDialog)="isAddFeeStructure = false"
        (reload)="reloadData()"></app-create-fee-structure>
</p-dialog>


<p-dialog [modal]="true" *ngIf="isEditStructure" [(visible)]="isEditStructure"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-create-fee-structure [type]="'Update'" [feeStructureData]="selectedRowData" [group_id]="feeGroupId"
        (closeDialog)="isEditStructure = false" (reload)="reloadData()"></app-create-fee-structure>
</p-dialog>

<p-dialog [modal]="true" *ngIf="deleteFeeStructure" [(visible)]="deleteFeeStructure"
    [breakpoints]="{ '1199px': '60vw', '575px': '90vw' }" closable="false" [style]="{ width: '40vw' }"
    [draggable]="false" [resizable]="false">
    <app-delete-fee-structure [academicYearData]="selectedRowData" (closeDialog)="deleteFeeStructure = false"
        (reload)="reloadData()"></app-delete-fee-structure>
</p-dialog>